<template>
  <div class="block block-rounded block-bordered">
    <div class="block-header block-header-default">
      <h3
        class="block-title"
        v-if="
          window.location.pathname === '/forms' ||
            window.location.pathname === '/'
        "
      >
        List of created forms
      </h3>
      <h3 class="block-title" v-if="window.location.pathname === '/search'">
        List of created forms (By Search)
      </h3>
      <div class="block-options">
        <div
          class="block-options-item"
          style="display: flex; flex-direction: row"
        >
          <div
            v-if="isLoading"
            class="spinner-border text-primary"
            role="status"
            style="display: inline-table; margin-right: 10px"
          ></div>
          <input
            type="text"
            id="search"
            class="form-control"
            placeholder="Search"
            style="margin-right: 10px"
            @keypress="handleKeyPress"
          />
          <button
            class="btn btn-success"
            style="margin-right: 15px"
            @click="searchForms()"
          >
            Search
          </button>
          <a class="btn btn-success" href="/editor/0" ref="tooltiphide">
            <i class="fas fa-plus text-white"></i>
          </a>
        </div>
      </div>
    </div>
    <div class="block-content">
      <table class="table table-hover table-vcenter">
        <thead>
          <tr>
            <th class="text-center" style="width: 50px">#</th>
            <th>Name</th>
            <th class="d-none d-sm-table-cell">Form Type</th>
            <th class="d-none d-sm-table-cell">Action Type</th>
            <th class="d-none d-sm-table-cell">Created</th>
            <th class="d-none d-sm-table-cell">Status</th>
            <th class="text-center" style="width: 100px">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, key) in allForms.data" :key="item.id">
            <th class="text-center" scope="row">
              {{
                $route.query.page > 1
                  ? parseInt($route.query.page) * 10 + key + 1
                  : key + 1
              }}
            </th>
            <td class="font-w600">
              <a :href="'/iframe/' + item.id"> {{ item.name }}</a>
            </td>
            <td>
              <span v-if="item.type == 0" class="badge" style="color: black"
                >Public</span
              >
              <span v-if="item.type == 1" class="badge" style="color: black"
                >Client</span
              >
            </td>
            <td>
              <span v-if="item.action == 0" class="badge" style="color: black"
                >Lead</span
              >
              <span v-if="item.action == 1" class="badge" style="color: black"
                >Contract</span
              >
            </td>
            <td class="d-none d-sm-table-cell">
              <span>{{ item.created_at | moment }}</span>
            </td>
            <td class="d-none d-sm-table-cell">
              <span v-if="item.status === 1" class="badge btn-warning"
                >Draft</span
              >
              <span v-if="item.status === 2" class="badge btn-success"
                >Publish</span
              >
            </td>
            <td class="text-left">
              <div class="btn-group">
                <a
                  @click="copyIFrame(item)"
                  tag="button"
                  href="#"
                  type="button"
                  class="btn btn-sm btn-outline-secondary"
                  data-toggle="tooltip"
                  title="Copy Iframe Code"
                  v-if="item.type != 1"
                >
                  <i class="fa fa-link"></i>
                </a>
                <span title="Copy Iframe Code for Client" data-toggle="tooltip">
                  <a
                    type="button"
                    tag="button"
                    href="#"
                    class="btn btn-sm btn-outline-secondary"
                    style="
                      border-radius: 3px;
                      border-top-right-radius: 0;
                      border-bottom-right-radius: 0;
                    "
                    data-toggle="modal"
                    data-target="#client"
                    @click="clientItem = item"
                    onclick="this.blur()"
                    v-if="item.type == 1"
                  >
                    <i class="fa fa-link"></i>
                  </a>
                </span>
                <button
                  tag="button"
                  @click="cloneForm(item.id)"
                  type="button"
                  class="btn btn-sm btn-outline-secondary"
                  data-toggle="tooltip"
                  title="Clone Form"
                >
                  <i class="fa fa-file"></i>
                </button>
                <button
                  tag="button"
                  @click="goTo('/iframe/' + item.id)"
                  type="button"
                  class="btn btn-sm btn-outline-secondary"
                  data-toggle="tooltip"
                  title="View Iframe"
                  :disabled="item.status == 1"
                >
                  <i class="fa fa-external-link-alt"></i>
                </button>
                <a
                  tag="button"
                  :href="'/editor/' + item.id"
                  type="button"
                  class="btn btn-sm btn-outline-primary"
                  style="border-right: none"
                  data-toggle="tooltip"
                  title="Edit"
                >
                  <i class="fa fa-pencil-alt"></i>
                </a>
                <a
                  tag="button"
                  type="button"
                  class="btn btn-sm btn-outline-danger"
                  data-toggle="tooltip"
                  title="Delete"
                  @click="deleteForm(item.id)"
                >
                  <i class="fa fa-times"></i>
                </a>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="row">
        <div class="col-12 pb-3 pr-4">
          <div
            class="btn-group btn-group-lg float-right"
            role="group"
            aria-label="Large Horizontal Outline Primary"
          >
            <br />
            <button
              tag="button"
              :href="'/formManager'"
              type="button"
              class="btn btn-outline-primary"
              style="font-size: 15px; margin-right: 15px"
              data-toggle="tooltip"
              @click="handleFormManager()"
            >
              Form Manager
              <i class="fa fa-plus"> </i>
            </button>
            <button
              tag="button"
              :href="'/formManager2'"
              type="button"
              class="btn btn-outline-primary"
              style="font-size: 15px; margin-right: 15px"
              data-toggle="tooltip"
              @click="handleFormManager2()"
            >
              Form Manager 2
              <i class="fa fa-plus"> </i>
            </button>
            <a
              v-if="currentPage !== 1 && currentPage !== 0"
              :href="
                window.location.pathname === '/search'
                  ? '/search?key=' + searchKey + '&page=' + (currentPage - 1)
                  : 'forms?page=' + (currentPage - 1)
              "
            >
              <button type="button" class="btn btn-outline-info">
                <i class="fa fa-arrow-left"></i>
              </button>
            </a>
            <a href="javascript:void(0)">
              <button
                type="button"
                class="btn btn-outline-info ml-3 mr-3"
                disabled
              >
                {{ currentPage }}
              </button>
            </a>
            <a
              v-if="currentPage !== lastPage"
              :href="
                window.location.pathname === '/search'
                  ? '/search?key=' + searchKey + '&page=' + (currentPage + 1)
                  : 'forms?page=' + (currentPage + 1)
              "
            >
              <button type="button" class="btn btn-outline-info">
                <i class="fa fa-arrow-right"></i>
              </button>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      id="client"
      role="dialog"
      aria-hidden="true"
      ref="tooltiphider"
    >
      <Dialog :clientItem="clientItem" ref="dialog" />
    </div>
  </div>
</template>
<script>
import { mapActions, mapState, mapMutations } from "vuex";
import Dialog from "./dialog";
import moment from "moment";
export default {
  name: "FormsList",
  data: () => {
    return {
      currentPage: 1,
      lastPage: 1,
      clientItem: {
        name: "Name",
        clients: []
      },
      observer: null,
      isLoading: false,
      window: window,
      searchKey: "",
      selectedForms: []
    };
  },
  methods: {
    ...mapActions({
      getAllForm: "forms/getAllForm",
      deleteFormById: "forms/deleteFormById",
      cloneFormById: "forms/cloneFormById",
      searchFormByName: "forms/searchFormByName"
    }),
    ...mapMutations({
      setSearchKey: "forms/SET_FORM_SEARCH_KEY"
    }),
    moment: function() {
      return moment();
    },
    handleFormManager2() {
      window.location.href = `/formManager2`;
    },
    handleFormManager() {
      // if (this.selectedForms.length > 3) {
      //   this.$swal.fire({
      //     icon: "warning",
      //     title: "",
      //     html: "Please select 3 forms"
      //   });
      // } else {
      //   localStorage.setItem(
      //     "selectedForms",
      //     JSON.stringify(this.selectedForms)
      //   );
      //   window.location.href = "/formManager";
      // }
      window.location.href = `/formManager`;
    },
    handleSelectedForms(e, item) {
      if (e.target.checked) {
        this.selectedForms.push(item.id);
      } else {
        this.selectedForms.map((id, index) => {
          if (id === item.id) {
            this.selectedForms.splice(index, 1);
          }
        });
      }

      console.log(this.selectedForms);
    },
    handleKeyPress(e) {
      if (e.key === "Enter") {
        this.searchForms();
      }
    },
    async searchForms() {
      this.isLoading = true;
      let searchKey = document.getElementById("search").value;
      this.setSearchKey(searchKey);
      if (searchKey === "" || !searchKey) {
        window.location.href = "/forms";
      } else {
        window.location.href = "/search?key=" + searchKey + "&page=1";
      }
      this.isLoading = false;
    },
    cloneForm(id) {
      this.cloneFormById(id).then(() => {
        this.getAllForm().then(response => {
          this.currentPage = response.data.meta.current_page;
          this.lastPage = response.data.meta.last_page;
        });
      });
    },
    deleteForm: function(id) {
      if (confirm("Do you really want to delete?")) {
        this.deleteFormById(id).then(() => {
          this.getAllForm().then(() => {});
        });
      }
    },
    copyIFrame(item) {
      let iframeLink =
        '<iframe src="' +
        process.env.VUE_APP_ROOT_PATH +
        "iframe/" +
        item.id +
        '" width="100%" scrolling="no" id="arxiframe" style="border: none" frameborder="0"></iframe>' +
        '<script type="text/javascript" src="' +
        process.env.VUE_APP_ROOT_PATH +
        'js/arxiframe.js"></scr' +
        "ipt>";
      const el = document.createElement("textarea");
      el.value = iframeLink;
      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
    },
    goTo(URL) {
      window.open(URL, "_blank");
    }
  },
  computed: {
    ...mapState({
      allForms: state => state.forms.AllForms,
      formSearchKey: state => state.forms.formSearchKey
    })
  },
  mounted() {
    //hide tooltip after dialog is closed
    this.observer = new MutationObserver(() => {
      setTimeout(() => {
        this.$refs["tooltiphide"].focus();
        this.$refs["tooltiphide"].blur();
      }, 350);
    });
    this.observer.observe(this.$refs["tooltiphider"], {
      attributes: true,
      attributeFilter: ["class"]
    });
    if (window.location.search.split("&").filter(x => x.includes("key"))[0]) {
      this.searchKey = window.location.search
        .split("&")
        .filter(x => x.includes("key"))[0]
        .split("=")[1];
      var url = new URL(window.location.href);
      var key = url.searchParams.get("key");

      this.searchKey = key;
    }
    document.getElementById("search").value = this.searchKey;
    if (window.location.pathname === "/search") {
      this.searchFormByName({ key: this.searchKey, pageSize: 10 }).then(
        response => {
          this.currentPage = response.data.meta.current_page;
          this.lastPage = response.data.meta.last_page;
        }
      );
    } else {
      this.getAllForm().then(response => {
        this.currentPage = response.data.meta.current_page;
        this.lastPage = response.data.meta.last_page;
      });
    }
  },
  components: {
    Dialog
  },
  filters: {
    moment: function(date) {
      //return moment(date).format("MMMM Do YYYY, h:mm:ss a");
      return moment(date).format("DD-MM-YYYY, H:mm:ss");
    }
  }
};
</script>
<style scoped></style>
